import { combineReducers } from 'redux';
import { getFormValues } from 'redux-form';
import axios from 'axios';;
import _ from 'lodash';
import qs from 'qs';
import * as Urls from 'src/constants/EndpointUrls';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import {
  fetchList,
  fetchListSuccess,
  fetchListFailure,
  setExtras
} from 'src/reducers/common/listReducer';
import { setItemExtra } from 'src/reducers/common/itemReducer';
import { serializeHttpGetParams, redirectTo } from 'src/utils/Http';
import {
  takePaysSearchQueries
} from 'src/reducers/searchForm';

export const REDUCER_NAME = 'reportPnds';
export const setDownloadPndOnlineData = () => setItemExtra(REDUCER_NAME, {pndErrors});
export const clearDownloadPndOnlineData = () => setItemExtra(REDUCER_NAME, { pndErrors: '' });

export const fetchReportPnds = (formValues, isFetchGrouped) => async dispatch => {
  try {
    dispatch(fetchList(REDUCER_NAME));
    let params = null;
    if (isFetchGrouped) {
      params = { grouped_payment_months: formValues.groupedPaymentMonths, client_branch_id: formValues.offices };
    } else {
      params = takePaysSearchQueries(formValues);
    }

    const fetchUrl = `${Urls.SEARCH_PND_DATA}?${serializeHttpGetParams(params)}`;
    const response = await axios.get(fetchUrl);
    const employeePays = response.data.payload.employeePays;
    const payload = { data: employeePays, pageCount: 0 };
    const { totalIncomes, totalWithholdingTaxes, totalEmployees, targetPeriod } = response.data.payload;
    dispatch(fetchListSuccess(REDUCER_NAME, payload));
    dispatch(setExtras(REDUCER_NAME, { totalIncomes, totalWithholdingTaxes, totalEmployees, targetPeriod }))
  } catch (exception) {
    dispatch(fetchListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
}

export const downloadPndOnline = (data, formValues) => async dispatch => {
  try {
    dispatch(clearDownloadPndOnlineData())
    const params = { grouped_payment_months: formValues.groupedPaymentMonths, client_branch_id: formValues.offices, tax_type: data.tax_type, format_type: data.format_type };
    const url = `${Urls.DOWNLOAD_PND_ONLINE_DATA}?${serializeHttpGetParams(params)}`;
    await axios.get(url);
    redirectTo(url);
  } catch (exception) {
    const errs = _.get(exception, ['response', 'data', 'errors', 'messages']) || [exception.message];
    dispatch(setDownloadPndOnlineData(errs));
  }
}
export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
